import { currencyExchangeRateFields } from '@/models/currencyExchangeRates';
import type { DataTableHeader } from '@/types/vuetify';

export function createCurrencyExchangePageHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        { title: t('currencyExchange.columns.date'), value: 'created_at', key: 'created_at', align: 'start', sortable: false, nowrap: true },
        ...currencyExchangeRateFields.map(({ key, label }) => ({
            title: t(`currencyExchange.columns.${label}`),
            value: key,
            key,
            align: 'end' as const,
            sortable: false,
            nowrap: true,
        })),
        { title: '', value: 'actions', key: 'actions', align: 'end', sortable: false, nowrap: true, width: 24, cellProps: { class: 'pl-0 pr-1' } },
    ];
}
